<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.riskAssessmentCategory") }}
    </heading>

    <riskAssessmentCategoryTable />
  </div>
</template>

<script>
import riskAssessmentCategoryTable from "@/views/riskAssessment/riskAssessmentCategoryTable.vue";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
export default {
  name: "riskAssessmentCategory",
  components: { riskAssessmentCategoryTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.riskAssessmentCategory;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.riskAssessmentCategory;
      }
      return sidebarTextDE.default.riskAssessmentCategory;
    },
  },
};
</script>
